import React, { useState, useEffect } from "react";
import DropdownRight from "./DropdownRight";
import Nav from "../components/Nav";
import dots from "../assets/images/dots.svg";
import http from "../services/http";
import polygon from "../assets/images/Polygon 56.png";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { SpinnerCircular } from "spinners-react";
import { Modal } from "react-bootstrap";
import { showToast } from "./ShowToast";
import { ToastContainer } from "react-toastify";

const AdsListing = () => {
  const token = localStorage.getItem("xAuthToken");
  const [rawVideo, setrawVideo] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showModal, setShow] = useState(false);

  const [selectedId, setSelectedId] = useState(0);

  const [deleteSpin, setDeleteSpin] = useState(false);
  const [statusSpin, setStatusspin] = useState(false);
  const [spinId, setSpinId] = useState(0);

  const handleClose = () => {
    setShow(false);
    setError("");
  };

  const handleShow = (id) => {
    setSelectedId(id);
    setShow(true);
  };

  useEffect(() => {
    AdVideos();
  }, []);

  const AdVideos = async () => {
    setLoading(true);

    http
      .get(`api/admin/ad?token=${token}`)
      .then((res) => {
        console.log("res---->", res.data);
        setLoading(false);

        setrawVideo(res.data);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  const DeleteVideo = async () => {
    setDeleteSpin(true);

    http
      .delete(`api/admin/ad/${selectedId}?token=${token}`)
      .then((res) => {
        setDeleteSpin(false);
        setrawVideo(rawVideo.filter((element) => element.id !== selectedId));
        console.log("res delete----->", res.data);
        handleClose();
        showToast("success", res.data.message);
      })
      .catch((error) => {
        console.log("error----->", error);

        setDeleteSpin(false);
      });
  };

  function availibilityChange(e, id) {
    setSpinId(id);
    const status = e.target.checked ? 1 : 0;
    setStatusspin(true);
    http
      .put(`api/admin/ad/activation/${id}?token=${token}`, {
        status,
      })
      .then((res) => {
        const newArr = rawVideo.map((el) => {
          if (el.id === id) {
            el.status = status;
          }
          return el;
        });
        setStatusspin(false);
        setSpinId(0);
        showToast("success", res.data.message);
        setrawVideo(newArr);
      })
      .catch((error) => {
        showToast("error", error.response.message);

        setStatusspin(false);
        setSpinId(0);
      });
  }

  const handleAdRunChange = async (item, field, value) => {

    http
      .put(`api/admin/ad/update-video-run/${item.id}?token=${token}`, {
        [field]: value,
      })
      .then((res) => {
        showToast("success", res.data.message);
        AdVideos();
      })
      .catch((error) => {
        showToast("error", error.response.message);
      });
  };

  return (
    <>
      <div class="wrapper">
        <Nav />
        <div id="content">
          <header>
            <div class="dashboard_header">
              <div class="left-side d-flex ">
                {" "}
                <button
                  type="button"
                  id="sidebarCollapse"
                  class="btn btn-link bt_none"
                >
                  <i class="fa fa-align-left"></i>{" "}
                </button>
                <h1>Ads Listing</h1>
              </div>
              <div class="user_profile   ">
                <DropdownRight />
              </div>
            </div>
          </header>
          <div class="dashbord_content">
            <div class="analysts-wraper-head">
              <div class="form-group search_wraper"></div>
              <div class="map_btn" style={{ marginBottom: 30 }}>
                {" "}
                <Link to="/adManagement" class="them_btn">
                  Add New
                </Link>
              </div>
            </div>
            <div class="table_vedio_upload dashbord_table    team_table mb_30 over_flow mb-0">
              <table class="table table-borderless table-responsive-md">
                <thead>
                  <tr>
                    <th scope="col" class="  pl_25">
                      Video
                    </th>
                    <th scope="col" class=" ">
                      Status
                    </th>
                    <th scope="col" className="">
                      Ad Run Selection
                    </th>
                    <th scope="col" class="text-center">
                      actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {/* {loading ? (
                    <div
                      style={{
                        position: "absolute",
                        marginTop: 100,
                        backgroundColor: "#ffffffc2",
                        marginLeft: 580,

                        backgroundBlendMode: "overlay",
                        zIndex: 100,
                      }}
                    >
                      <SpinnerCircular size="15%" />
                    </div>
                  ) : (
                    ""
                  )} */}
                  {rawVideo?.map((item, index) => (
                    <tr>
                      <td>
                        <div style={{ marginTop: 10 }}>
                          <Link
                            style={{
                              position: "relative",
                            }}
                            to="/video"
                            state={{
                              name: item.video,
                            }}
                          >
                            <video
                              style={{ objectFit: "cover" }}
                              width={130}
                              height={70}
                              src={item.video}
                            ></video>
                            <img
                              src={polygon}
                              alt=""
                              style={{
                                position: "absolute",
                                marginTop: 23,
                                marginLeft: -70,
                                width: 20,
                                height: 20,
                              }}
                            />
                          </Link>
                        </div>
                      </td>
                      <td>
                        <div class="switch_wraper" dataid={item.id}>
                          <input
                            type="checkbox"
                            hidden="hidden"
                            id={"status" + item.id}
                            value={item.id}
                            checked={item.status}
                            onClick={(e) => availibilityChange(e, item.id)}
                          />
                          <label
                            class="switch"
                            for={"status" + item.id}
                          ></label>
                          {/* {statusSpin && spinId === item.id ? (
                            <SpinnerCircular size={"7%"} />
                          ) : (
                            ""
                          )} */}
                        </div>
                      </td>
                      <td>
                        <div>
                          <label>
                            <input
                              type="checkbox"
                              style={{ marginRight: 5 }}
                              checked={item.isAdRunStart === 1}
                              onChange={(e) => handleAdRunChange(item, "isAdRunStart", e.target.checked ? 1 : 0)}
                            />
                            Start
                          </label>
                          <label style={{ marginLeft: 10 }}>
                            <input
                              type="checkbox"
                              style={{ marginRight: 5 }}
                              checked={item.isAdRunMiddle === 1}
                              onChange={(e) => handleAdRunChange(item, "isAdRunMiddle", e.target.checked ? 1 : 0)}
                            />
                            Middle
                          </label>
                          <label style={{ marginLeft: 10 }}>
                            <input
                              type="checkbox"
                              style={{ marginRight: 5 }}
                              checked={item.isAdRunEnd === 1}
                              onChange={(e) => handleAdRunChange(item, "isAdRunEnd", e.target.checked ? 1 : 0)}
                            />
                            End
                          </label>
                        </div>
                      </td>
                      <td className="text-center">
                        <div className="dropdown wraper_btn">
                          <Dropdown>
                            <Dropdown.Toggle
                              className="btn dropdown-toggle"
                              variant="success"
                              id="dropdown-basic"
                            >
                              <img
                                src={dots}
                                className="img-fulid"
                                alt="dropdown"
                              />
                            </Dropdown.Toggle>

                            <Dropdown.Menu as="ul" className="dropul">
                              <Dropdown.Item
                                as="li"
                                onClick={() => handleShow(item.id)}
                              >
                                Delete Video
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Modal className="starrating" show={showModal} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Are you sure?</Modal.Title>
          <button
            onClick={handleClose}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            {" "}
            <span aria-hidden="true">&times;</span>{" "}
          </button>
        </Modal.Header>
        <Modal.Body>
          <div class="raing_star">
            <p>Are you sure you want to delete.</p>
          </div>
          <div className="modal-footer border-top-0">
            <button
              onClick={handleClose}
              type="button"
              className=" them_btn_ouline  "
            >
              Cancel
            </button>
            <button
              onClick={DeleteVideo}
              type="button"
              className="them_btn1 "
              data-toggle="modal"
              data-target="#new_team_add_yes"
            >
              {deleteSpin ? <SpinnerCircular /> : " Confirm"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <ToastContainer />
    </>
  );
};

export default AdsListing;
